// @flow strict
import styled from "styled-components";

const PracticeAreasTitle = styled.h3.attrs({ className: "text-uppercase" })`
  margin-bottom: 0.5rem;
`;

export default PracticeAreasTitle;
